export enum StatsEnum {
    AccountTransactions = 'account_transactions',
    BookkeeperTransactions = 'bookkeeper_transactions',
    BookkeeperLeads = 'bookkeeper_leads',
    Processes = 'processes'
}
